export default __webpack_public_path__ + "static/media/Suarez.f7303c23.jpg";